let reporter = null;

export const setErrorReporter = (fn) => {
  reporter = fn;
};

export const reportError = (error, context = {}) => {
  const enriched = {
    timestamp: new Date().toISOString(),
    ...context,
  };

  if (reporter) {
    reporter(error, enriched);
  } else {
    console.error("Error (no reporter):", error, enriched);
  }
};